import React from "react";

import { RideGlInformationOutline } from "@rimac-seguros/ride-system-components";

import { Chips } from "@/components/atoms/Chips";

export const PaymentFrequency = ({ list, frequency, onSelected }) => {
  const selectFrequency = (item) => {
    if (frequency && frequency.value === item) return;
    onSelected(item);
  };

  return (
    <div className="relative border-b py-ride-gl-spacing-4xlarge border-ride-sys-color-border-default">
      <h2 className="ride-sys-text-title-xlarge-default mb-ride-gl-spacing-2xlarge lg:mb-ride-gl-spacing-4xlarge lg:ride-sys-text-title-2xlarge-default">
        Elige tu frecuencia de pago
      </h2>
      <div className="flex gap-ride-gl-spacing-2xlarge">
        {list.map((item) => (
          <Chips
            key={item.value}
            selected={item.value === frequency}
            onClick={() => selectFrequency(item.value)}
          >
            {item.text}
          </Chips>
        ))}
      </div>
      <div className="mt-ride-gl-spacing-4xlarge flex gap-ride-gl-spacing-large">
        <RideGlInformationOutline size="large" />
        <p className="ride-sys-text-paragraph-small-default">Es posible retirar parte de tus fondos antes del plazo acordado. La cantidad dependerá del tiempo ahorrado.</p>
      </div>
    </div>
  );
};
